export const ASSETS = {
  hero: "https://images.pexels.com/photos/36873712/pexels-photo-36873712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  chandelier: "https://images.unsplash.com/photo-1778049336897-59d062562211?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  couple: "https://images.unsplash.com/photo-1591604466107-ec97de577aff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mandap: "https://images.unsplash.com/photo-1587271636175-90d58cdad458?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sparkler: "https://images.unsplash.com/photo-1760080839536-1936f4ec2c23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  floral: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dining: "https://images.unsplash.com/photo-1561593367-66c79c2294e6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  corporate: "https://images.unsplash.com/photo-1543283864-0eba98564bd4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  birthday: "https://images.unsplash.com/photo-1741969494307-55394e3e4071?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const EVENT_TYPES = [
  "Wedding", "Destination Wedding", "Engagement", "Birthday", "Anniversary",
  "Baby Shower", "Cultural Show", "Corporate Conference", "Product Launch",
  "Dealer Meet", "Award Night", "Other",
];

export const BUDGET_RANGES = [
  "Under ₹2 Lakh", "₹2–5 Lakh", "₹5–10 Lakh", "₹10–25 Lakh", "₹25 Lakh+",
];

export const SERVICE_OPTIONS = [
  "Venue", "Catering", "Decor & Floral", "Photography & Video", "Bridal Makeup",
  "Mehandi", "Stage / Mandap", "Transport", "Boarding & Lodging", "Card Printing",
  "Lighting & Sound", "Pandit Ji & Pooja Samgiri",
];
